module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921075649_T.82be03c5.jpg";